if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;
        
        // Get quantity buttons and product type
        this.minusButton = this.querySelector('.quantity__button[name="minus"]');
        this.productType = this.closest('[data-product-type]')?.dataset.productType || '';
        
        // Initial check for button state
        this.updateMinusButtonState();
        
        // Set up observers to watch for quantity changes
        this.setupQuantityObserver();

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }
      
      setupQuantityObserver() {
        // Create observer to watch for quantity changes
        const quantityObserver = new MutationObserver(() => {
          this.updateMinusButtonState();
        });
        
        // Find the quantity element to observe
        const quantityElement = this.querySelector('.quick-add__current-qty') || 
                               this.querySelector('.quantity__input');
                               
        if (quantityElement) {
          quantityObserver.observe(quantityElement, { 
            characterData: true,
            attributes: true,
            childList: true,
            subtree: true 
          });
        }
      }
      
      updateMinusButtonState() {
        if (!this.minusButton) return;
        
        // Get current quantity
        const quantityElement = this.querySelector('.quick-add__current-qty') || 
                               this.querySelector('.quantity__input');
        if (!quantityElement) return;
        
        let currentQuantity = quantityElement.textContent || quantityElement.value || '';
        currentQuantity = currentQuantity.trim().toLowerCase();
        
        let disableMinus = false;
        
        // Apply different logic based on product type
        if (this.productType === 'Half Yard') {
          // For Half Yard products, disable if quantity is "½ yard"
          disableMinus = currentQuantity === '½ yard';
        } else {
          // For other products, disable if quantity is 1 yard
          disableMinus = currentQuantity === '1 yard' || currentQuantity === '1';
        }
        
        // Update button state
        if (disableMinus) {
          this.minusButton.setAttribute('disabled', '');
          this.minusButton.classList.add('disabled');
        } else {
          this.minusButton.removeAttribute('disabled');
          this.minusButton.classList.remove('disabled');
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

// Add listener for quantity updates from other sources
document.addEventListener('DOMContentLoaded', () => {
  // Watch for cart changes that might affect quantities
  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('quantity-popover').forEach(popover => {
        if (typeof popover.updateMinusButtonState === 'function') {
          popover.updateMinusButtonState();
        }
      });
    });
  }
});